import { API_BASE_URL } from "./config";

export const getHome = () => {
  return fetch(`${API_BASE_URL}/api/v1/homePage/home`, {
    method: "GET",
  });
};

export const getProducts = () => {
  return fetch(`${API_BASE_URL}/api/v1/drug/drugs`, {
    method: "GET",
  });
};

export const getNews = () => {
  return fetch(`${API_BASE_URL}/api/v1/news/news`, {
    method: "GET",
  });
};
